import { useState } from 'react'

import { EMPTY_FUNCTION_ASYNC } from '../../../../constants/common'
import { UserProfileWidgetPartnerInfo } from '../../../User'
import { Component, ComponentProps } from '../../Component'
import { boolean, controls, json } from '../../Controls'
import { MOCK_INFO_OPTIONS } from '../InhabitantProfile.constants'

import { PROFILE_PARTNER_INFO_INHABITANT_DATA } from './ProfilePartnerInfoWidgetInhabitant.constants'

function ProfilePartnerInfoWidgetInhabitant() {
  const [props, setProps] = useState(() =>
    controls() //
      .add(boolean('canEdit', true))
      .add(json('data', PROFILE_PARTNER_INFO_INHABITANT_DATA))
      .add(boolean('isSkeleton', false))
      .add(json('options', MOCK_INFO_OPTIONS))
  )

  return (
    <>
      <Component
        {...props.getValues()}
        Component={UserProfileWidgetPartnerInfo}
        name='UserProfileWidgetPartnerInfo'
        onSubmit={EMPTY_FUNCTION_ASYNC}
      />
      <ComponentProps
        name='UserProfileWidgetPartnerInfo'
        value={props}
        onChange={setProps}
      />
    </>
  )
}

export default ProfilePartnerInfoWidgetInhabitant
